import snakeCase from 'lodash/snakeCase'

const humanizedDateFormat = (t, format) => {
  // By passing an array to t, it will fallback to format if the translation is not found
  // Our parseMissingKeyHandler handles displaying the fallback
  return t([`common.date_time_input_placeholders.${snakeCase(format)}`, format])
}

export default humanizedDateFormat
